import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class SalesOrderExtendActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/SalesOrderLineExtendRequest/SalesOrderLineExtendRequestBrowser")
	}

	render() {
		return (
			<Activity 
				name="SalesOrderExtend"
				RenderedComponent={this.RenderedComponent}
				context="SalesOrderExtend"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(SalesOrderExtendActivity)
